import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '@app/service/header/header.service';
import {
  StandardCheckoutResponse,
  UserService,
} from '@app/service/user-service/user.service';
import { ResolveType, StateService } from 'src/app/service/state/state.service';
import { RouteComponent } from '../../route.component';
import { LoggingService } from '@app/service/logging-service/logging.service';

@Component({
  selector: 'app-de-verification-email',
  templateUrl: './de-rejected.component.html',
  styleUrls: ['../../page-shared.css', './de-rejected.component.scss'],
})
export class DeRejectedDeComponent extends RouteComponent implements OnInit {
  loading = false;
  navigationInProgress = false;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private userService: UserService,
    private loggingService: LoggingService
  ) {
    super(router, route, stateService, headerService);
  }

  ngOnInit(): void {
    this.redirectIfInstantRedirectActivated();
  }

  async redirectIfInstantRedirectActivated(): Promise<void> {
    if (this.state.interruptionDetails?.instantRedirect) {
      this.navigationInProgress = true;
      this.resolveInterruption(ResolveType.INSTANT_REDIRECT);
      this.navigationInProgress = false;
    }
  }

  async handleCtaClick(): Promise<void> {
    this.navigationInProgress = true;
    try {
      if (this.state.interruptionDetails?.cancelUrlOverridesCta) {
        const resp = await this.userService.cancelPayment();
        if (resp.success) {
          window.location.href = this.state.merchantUrls?.onCancelUrl;
        }
      } else {
        await this.resolveInterruption(ResolveType.CTA);
      }
    } catch (error) {
      console.log(error);
    }
    this.navigationInProgress = false;
  }

  async handleUpdateWebFormCtaClick(): Promise<void> {
    this.navigationInProgress = true;
    try {
      if (this.state.interruptionDetails?.cancelUrlOverridesCta) {
        const resp = await this.userService.cancelPayment();
        if (resp.success) {
          window.location.href = this.state.merchantUrls?.onCancelUrl;
        }
      } else {
        await this.resolveInterruption(ResolveType.CTA_BLACK);
      }
    } catch (error) {
      console.log(error);
    }
    this.navigationInProgress = false;
  }

  async handleLinkClick(): Promise<void> {
    this.navigationInProgress = true;

    this.loggingService.warn(
      `Attempted to handle link click from rejection page with the following interruptionDetails: +
      ${JSON.stringify(this.state.interruptionDetails)}`
    );

    try {
      if (this.state.interruptionDetails?.cancelUrlOverridesLink) {
        await this.userService
          .cancelPayment()
          .then((resp: StandardCheckoutResponse) => {
            if (resp.success) {
              window.location.href = this.state.merchantUrls?.onCancelUrl;
            }
          });
      } else if (this.state.interruptionDetails?.linkExternalDestination) {
        window.open(
          this.state.interruptionDetails?.linkExternalDestination,
          '_blank'
        );
      } else {
        await this.resolveInterruption(ResolveType.LINK);
      }
    } catch (error) {
      this.loggingService.warn(
        `Could not handle link click interruption from rejection due to: ${JSON.stringify(
          error
        )}`
      );
    }
    this.navigationInProgress = false;
  }
}
